import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Cpu, Coins } from "lucide-react";
import Header from "@/components/Header";
import HelpFab from "@/components/HelpFab";
import StakingCalculator from "@/components/StakingCalculator";
import BotCalculator from "@/components/BotCalculator";

const ASSETS = [
  { k: "ca", label: "CA staking", icon: Cpu, color: "#4060FF" },
  { k: "bot", label: "BOT pledge", icon: Coins, color: "#0E7490" },
];

// Two assets, two rate tables, one page. CA runs on CaryPact's published plan
// table; BOT runs on its own (see BotCalculator) because CaryPact publishes
// nothing we can read for it.
export default function Calculator() {
  const [params, setParams] = useSearchParams();
  const [asset, setAsset] = useState(params.get("asset") === "bot" ? "bot" : "ca");
  const pick = (k) => {
    setAsset(k);
    const next = new URLSearchParams(params);
    if (k === "ca") next.delete("asset"); else next.set("asset", k);
    setParams(next, { replace: true });
  };

  return (
    <div className="min-h-screen pb-24" data-testid="calculator-page">
      <Header variant="public" />
      <div className="px-6 md:px-10 pt-8">
        <div className="max-w-[1400px] mx-auto">
          <div className="glass p-1.5 inline-flex gap-1" data-testid="calc-asset-tabs">
            {ASSETS.map((a) => {
              const active = asset === a.k;
              const Icon = a.icon;
              return (
                <button key={a.k} type="button" onClick={() => pick(a.k)} data-testid={`calc-asset-${a.k}`}
                  className="px-4 py-2 rounded-xl text-[13px] font-semibold transition-colors inline-flex items-center gap-2"
                  style={active ? { background: a.color, color: "white" } : { background: "transparent", color: "#475569" }}>
                  <Icon size={14} /> {a.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
      {asset === "ca" ? <StakingCalculator /> : <BotCalculator />}
      <HelpFab />
    </div>
  );
}
